module.exports = __webpack_public_path__ + "static/arrow.up.dots.transparent-9238ec87b6155b4b1d028a4dac5e9ff2.png";